import { IApplicationState } from '../../types/redux';

export function selectIsCrossLinksEnabled(state: IApplicationState) {
  return state.features.crossLinksEnabled;
}
